import { Component, EventEmitter, Input, Output, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoriaMeta, MesCusto } from '../../shared/model/relatorio-custo.models';
import { BalaoAvisoComponent } from '../../shared/components/balao-aviso/balao-aviso.component';

type MetaKey = CategoriaMeta;

@Component({
  selector: 'app-visao-mensal',
  standalone: true,
  imports: [CommonModule, BalaoAvisoComponent],
  templateUrl: './visao-mensal.component.html',
  styleUrls: ['./visao-mensal.component.css'],
})
export class VisaoMensalComponent {
  @Input({ required: true }) ano!: number;

  private mesSig = signal<MesCusto | null>(null);
  @Input()
  set mes(v: MesCusto | null) { this.mesSig.set(v); }
  get mes() { return this.mesSig(); }

  @Input() loading = false;
  @Input() metaToggle = false;
  @Output() toggleMeta = new EventEmitter<boolean>();

  minSegPct = 6;

  setoresOrdenados = computed(() => {
    const setores = this.mesSig()?.porSetor ?? [];
    return [...setores].sort((a, b) => (b.total ?? 0) - (a.total ?? 0));
  });

  totalMes = computed(() => this.mesSig()?.total ?? 0);
  semDados = computed(() => {
    if (this.loading) {
      return false;
    }

    const mes = this.mesSig();
    if (!mes) {
      return true;
    }

    if ((mes.total ?? 0) > 0) {
      return false;
    }

    return !(mes.porSetor ?? []).some((setor) =>
      (setor.total ?? 0) > 0 ||
      (setor.porTemplate ?? []).some((template) => (template.total ?? 0) > 0)
    );
  });

  metaColors: Record<MetaKey, string> = {
    MARKETING: '#6213B6',
    UTILITY: '#09537D',
    AUTHENTICATION: '#430F7B',
  };

  percentForBigBar(part: number, total: number) {
    const p = this.percent(part, total);
    if (p > 0 && p < this.minSegPct) return this.minSegPct;
    return p;
  }

  setorSegColor(index: number) {
  const n = this.setoresOrdenados().length || 1;

  const maxA = 0.69;
  const minA = 0.10;

  const t = n === 1 ? 0 : index / (n - 1);

  const curve = Math.pow(t, 1.6);

  const a = maxA + (minA - maxA) * curve;

  return `rgba(153, 61, 245, ${a.toFixed(2)})`;
}

  formatUSD(value: number) {
    return (value ?? 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  percent(part: number, total: number) {
    if (!total || total <= 0) return 0;
    return Math.max(0, Math.min(100, (part / total) * 100));
  }

  getMetaPart(obj: any, key: MetaKey): number {
    return obj?.porCategoriaMeta?.[key] ?? 0;
  }

  getSetorMetaTotal(setor: any, key: MetaKey): number {
    const list = setor?.porTemplate ?? [];
    return list.reduce((acc: number, t: any) => acc + (this.getMetaPart(t, key) ?? 0), 0);
  }

  setorPercentLabel(setorTotal: number) {
    return `${Math.round(this.percent(setorTotal, this.totalMes()))}%`;
  }

  onToggleMeta() {
    this.toggleMeta.emit(!this.metaToggle);
  }
}
